__turbopack_context__.v({
  "arrow": "productsSection-module-scss-module__oT8oRa__arrow",
  "container": "productsSection-module-scss-module__oT8oRa__container",
  "disabled": "productsSection-module-scss-module__oT8oRa__disabled",
  "image": "productsSection-module-scss-module__oT8oRa__image",
  "intro": "productsSection-module-scss-module__oT8oRa__intro",
  "link": "productsSection-module-scss-module__oT8oRa__link",
  "outerWrapper": "productsSection-module-scss-module__oT8oRa__outerWrapper",
  "product": "productsSection-module-scss-module__oT8oRa__product",
  "productsSection": "productsSection-module-scss-module__oT8oRa__productsSection",
  "sectionInner": "productsSection-module-scss-module__oT8oRa__sectionInner",
  "sectionTextInfo": "productsSection-module-scss-module__oT8oRa__sectionTextInfo",
  "title": "productsSection-module-scss-module__oT8oRa__title",
  "withImage": "productsSection-module-scss-module__oT8oRa__withImage",
  "wrapper": "productsSection-module-scss-module__oT8oRa__wrapper",
});
